export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_EMAIL = "SET_EMAIL";
export const SET_PHONE = "SET_PHONE";
export const SET_DELIVERY_OPTION = "SET_DELIVERY_OPTION";
export const SET_STORE_LOCATION = "SET_STORE_LOCATION";


export function setFirstName(first_name) {
    return {
        type: SET_FIRST_NAME,
        first_name
    }
}

export function setLastName(last_name) {
    return {
        type: SET_LAST_NAME,
        last_name
    }
}

export function setEmail(email) {
    return {
        type: SET_EMAIL,
        email
    }
}

export function setPhone(phone) {
    return {
        type: SET_PHONE,
        phone
    }
}

export function setDeliveryOption(deliveryOption) {
    return {
        type: SET_DELIVERY_OPTION,
        deliveryOption
    }
}

export function setStoreLocation(location) {
    return {
        type: SET_STORE_LOCATION,
        location
    }
}